import Vue from "vue";
import Router from "vue-router";

/* Components */
import Home from "@/views/Home";
import Post from "@/views/Post";
import QuemSomos from "@/views/QuemSomos";
import Contato from "@/views/Contato";
import Search from "@/views/Search";
import Parceiros from "@/views/Parceiros";
import Autor from "@/views/Autor";
import SejaEditor from "@/views/SejaEditor";
import Doacao from "@/views/Doacao";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "Home"
      }
    },
    {
      path: "/post/:slug",
      name: "Post",
      component: Post,
      meta: {
        title: "Post"
      }
    },
    {
      path: "/QuemSomos",
      name: "QuemSomos",
      component: QuemSomos,
      meta: {
        title: "Quem Somos"
      }
    },
    {
      path: "/parceiros",
      name: "Parceiros",
      component: Parceiros,
      meta: {
        title: "Parceiros"
      }
    },
    {
      path: "/Contato",
      name: "Contato",
      component: Contato,
      meta: {
        title: "Contato"
      }
    },
    {
      path: "/busca",
      name: "Search",
      component: Search,
      meta: {
        title: "Busca"
      }
    },
    {
      path: "/autor/:id",
      name: "Autor",
      component: Autor,
      meta: {
        title: "Autor"
      }
    },
    {
      path: "/sejaEditor",
      name: "SejaEditor",
      component: SejaEditor,
      meta: {
        title: "Seja um Editor"
      }
    },
    {
      path: "/doacao",
      name: "Doacao",
      component: Doacao,
      meta: {
        title: "Doação"
      }
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.afterEach(to => {
  document.title = to.meta.title || "Pedline";
  // window.dataLayer.push({
  //   event: "Pageview",
  //   pageTitle: to.meta.title
  // });
  gtag("config", window.GA_TRACKING_ID, {
    page_path: to.fullPath,
    send_page_view: true,
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js